"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUsersCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zM9.448 7.2a2.77 2.77 0 011.18 5.278c1.529.46 2.674 1.782 2.763 3.319l.005.193v.262c0 .2-.142.368-.33.406l-.084.009H5.915a.415.415 0 01-.407-.331l-.008-.084v-.262c0-1.618 1.176-3.034 2.77-3.513A2.77 2.77 0 019.45 7.2zm5.497 0a2.378 2.378 0 011.1 4.487c1.375.43 2.397 1.638 2.453 3.035l.002.12v.232c0 .21-.156.384-.359.411l-.056.004H14.32a.415.415 0 01-.415-.415c0-.21-.207-.74-.49-1.235-.284-.494-.633-.81-.772-.992a.415.415 0 01.079-.581 3.644 3.644 0 011.125-.581A2.378 2.378 0 0114.945 7.2z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgUsersCircle;
exports.default = _default;